import { useNavigate } from "react-router-dom";
import useQueryParams from "./useQueryParams";

const useCustomNavigate = () => {
  const navigate = useNavigate();
  const {
    userId,
    storeNo,
    authToken,
    rscCd,
    userType,
    skuNumber,
    shipToCustomerPermission,
    discoveryPermission,
    everydayDropshipPermission,
    cpoPermission,
    stockReservePermission,
  } = useQueryParams();

  const buildUrlWithParams = (
    url: string,
    params: Record<string, any> = {}
  ) => {
    const defaultParams = {
      ...(userId && { userId }),
      ...(storeNo && { storeNo }),
      ...(authToken && { authToken }),
      ...(rscCd && { rscCd }),
      ...(userType && { userType }),
      ...(skuNumber && { skuNumber }),
      ...(shipToCustomerPermission && { shipToCustomerPermission }),
      ...(discoveryPermission && { discoveryPermission }),
      ...(everydayDropshipPermission && { everydayDropshipPermission }),
      ...(cpoPermission && { cpoPermission }),
      ...(stockReservePermission && { stockReservePermission }),
    };
    const allParams = { ...defaultParams, ...params };
    const searchParams = Object.keys(allParams)
      .map((key) => `${key}=${allParams[key]}`)
      .join("&");
    return searchParams ? `${url}?${searchParams}` : url;
  };

  const navigateWithParams = (
    path: string,
    options?: { params?: Record<string, any>; state?: any }
  ) => {
    const { params, state } = options || {};
    const url = buildUrlWithParams(path, params);
    navigate(url, { state });
  };

  const remoteNavigate = (url: string, params?: Record<string, any>) => {
    window.location.href = buildUrlWithParams(url, params);
  };

  return {
    navigateWithParams,
    remoteNavigate,
  };
};

export default useCustomNavigate;
